import { LoadingSpinner } from './LoadingSpinner'

interface LoadingOverlayProps {
  isVisible: boolean
  message?: string
}

export function LoadingOverlay({ isVisible, message = 'Procesando...' }: LoadingOverlayProps) {
  if (!isVisible) return null

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className="flex flex-col items-center gap-4 rounded-lg bg-white p-8 shadow-lg">
        <LoadingSpinner size="lg" />
        <p className="text-center text-sm font-medium text-foreground">{message}</p>
      </div>
    </div>
  )
}
